import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../../types';

export const Route = createFileRoute('/_private-routes/tiktok/ad-campaign-report')({
  staticData: {
    menuTitle: MenuTitle.TikTokAdsReport
  }
});
